import {LinkOutlined} from "@ant-design/icons";
import {Button, Dropdown} from "antd";
import styles from "./EntityLinks.module.css";

import {operatorToProject, properties} from "@/properties.js";
import {EntityLinks as EntityLinksVariant} from "../../../variants/index.js";
import {Link} from "react-router-dom";

export const LinkOutlinedButton = ({onClick, ref, ...rest}) => {
	return <Button ref={ref} icon={<LinkOutlined />} onClick={onClick} type={"link"} {...rest} />;
};

export const EntityLinksDropdown = ({operator, material, type, sortCode, triggerStyle = {}}) => {
	const systemLinks = EntityLinksVariant?.systemLinks ?? {};
	const extraLinks = EntityLinksVariant ? EntityLinksVariant.getExtraLinks(operator, material, type, sortCode) : [];
	const isOnInventoryItemPage =
		window.location.pathname.includes("/data") &&
		new URLSearchParams(window.location.search).get("operator") === operator &&
		new URLSearchParams(window.location.search).get("material") === String(material);
	const dropdownMenuItems = [
		systemLinks.analytics &&
			properties.analyticsLink && {
				key: "workbench",
				label: (
					<Link
						target="_blank"
						rel="noopener noreferrer"
						to={`${properties.analyticsLink}/projects/${operatorToProject(
							operator,
						)}/min-max-material-analysis?material=${material}`}
						data-testid="entitylinks-analytics-link">
						Workbench
					</Link>
				),
			},
		systemLinks.inventory &&
			properties.ihLink &&
			!isOnInventoryItemPage && {
				key: "inventory",
				label: (
					<Link
						target="_blank"
						rel="noopener noreferrer"
						to={`${properties.ihLink}/data?operator=${operator}&material=${material}`}
						data-testid="entitylinks-inventory-link">
						Inventory
					</Link>
				),
			},
		systemLinks.knowledge &&
			properties.khLink && {
				key: "knowledge",
				label: (
					<Link
						target="_blank"
						rel="noopener noreferrer"
						to={`${properties.khLink}&q=${sortCode ? (sortCode !== "NA" ? sortCode : material) : material}`}
						data-testid="entitylinks-knowledge-link">
						Knowledge
					</Link>
				),
			},
		systemLinks.equipment &&
			properties.assetHubLink && {
				key: "equipment",
				label: (
					<Link
						target="_blank"
						rel="noopener noreferrer"
						to={`${properties.assetHubLink}/entity_links?type=${type}&item=${material}`}
						data-testid="entitylinks-equipment-link">
						Equipment
					</Link>
				),
			},
		...(extraLinks?.map((link, idx) => ({
			key: `extra-link-${idx}`,
			label: (
				<Link target="_blank" rel="noopener noreferrer" to={link.href} data-testid={link.testId}>
					{link.label}
				</Link>
			),
		})) || []),
	].filter(Boolean);

	return (
		<Dropdown menu={{items: dropdownMenuItems}}>
			<LinkOutlinedButton className={styles.linkOutlined} data-testid="entitylinks-dropdown-trigger" />
		</Dropdown>
	);
};
